import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const DownloadIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 14'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M6.57394 13.0424L11.7927 7.8236L11.0915 7.12232L7.13337 11.0804L7.13337 0.577586L6.13849 0.577586L6.13849 11.1964L2.09012 7.148L1.38483 7.85329L6.57394 13.0424Z'
                fill='#2F2F2F'
                fillRule='evenodd'/>
            <path
                clipRule='evenodd'
                d='M12.1543 13.1541L0.840576 13.1541L0.840576 12.1592L12.1543 12.1592L12.1543 13.1541Z'
                fill='#2F2F2F'
                fillRule='evenodd'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default DownloadIcon;
